import { ICompanyAnsweredQuestion } from '../../../../common';
import { IconButton, Icon, Tooltip } from '../../../../base';
import {
    HistoryItemRow,
    QuestionText,
    AnswerText,
    AnswerIconContainer,
} from './ViewAnswerHistoryItem.styles';
import { useTranslation } from 'react-i18next';

interface Props {
    questionWithAnswer: ICompanyAnsweredQuestion;
    onEdit: () => void;
}

const ViewAnswerHistoryItem = ({ questionWithAnswer, onEdit }: Props) => {
    const { t } = useTranslation();
    const renderAnswer = (value: ICompanyAnsweredQuestion['answer']) => {
        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }
        if (Array.isArray(value)) {
            return value.join(', ');
        }
        return value;
    };

    return (
        <HistoryItemRow>
            <QuestionText variant="body1">
                {questionWithAnswer.title}
            </QuestionText>
            <AnswerIconContainer>
                <AnswerText variant="body2">
                    {renderAnswer(questionWithAnswer.answer)}
                </AnswerText>
                <Tooltip title={t('tools.editComingSoon')}>
                    <IconButton onClick={onEdit} size="small" disabled>
                        <Icon name="EditIcon" size={20} color="action" />
                    </IconButton>
                </Tooltip>
            </AnswerIconContainer>
        </HistoryItemRow>
    );
};

export default ViewAnswerHistoryItem;
